// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/components/material/tabs/tabs.less
// module id = 2090
// module chunks = 0 1 2